import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { compose, isEqual, hashArray } from '@elliemae/ds-utilities/utils';
import { getItemsById, pipe, prepareItems } from './helper.js';
import { addToTarget, resetMovedItems } from './Shuttle.actions.js';
import 'treetabular';
import './utils.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mergeToPrevState = function mergeToPrevState(prevState, nextState) {
  return _objectSpread(_objectSpread(_objectSpread({}, prevState), nextState), {}, {
    prevProps: _objectSpread(_objectSpread({}, prevState.prevProps), nextState.prevProps)
  });
};

function compareSelectedItems(nextProps, prevProps) {
  var selectedItems = nextProps.selectedItems,
      idField = nextProps.idField;
  return function (nextState) {
    if (isEqual(selectedItems, prevProps.selectedItems)) return nextState; // if we are using nonSelectedItems skip this legacy logic and paint just what's passed
    // to nonSelectedItems (source) and selectedItems (target)
    // TODO make controlledV2 the default behavior for controlled shuttle

    if (nextProps.nonSelectedItems) return nextState;
    var preparedItems = nextState.preparedItems;
    var prevSelectedItemsHash = hashArray(prevProps.selectedItems || []);
    var itemsToMove = getItemsById(selectedItems, preparedItems);
    var actions = itemsToMove.map(function (item) {
      return prevSelectedItemsHash[item[idField]] ? addToTarget(item, nextState.targetItems) : addToTarget(item);
    });
    return mergeToPrevState(nextState, _objectSpread(_objectSpread({}, pipe([resetMovedItems()].concat(_toConsumableArray(actions)))(nextState, nextProps)), {}, {
      prevProps: _objectSpread(_objectSpread({}, nextState.prevProps), {}, {
        selectedItems: selectedItems
      })
    }));
  };
}

function compareItems(nextProps, prevProps) {
  var items = nextProps.items;
  return function (nextState) {
    var preparedItems = prepareItems(items);
    var isControlledV2 = nextProps.nonSelectedItems; // TODO make controlledV2 the default behavior for controlled shuttle

    if (isControlledV2) {
      var targetItems = nextProps.selectedItems.map(function (id) {
        return preparedItems.find(function (it) {
          return it.id === id;
        });
      });
      return mergeToPrevState(nextState, {
        preparedItems: preparedItems,
        // PUI-4462 on async load and items change, the shuttle loads
        // all children from currently selected targetItems from items prop
        // (items prop update)
        targetItems: targetItems,
        movedItems: targetItems,
        prevProps: {
          items: items
        }
      });
    }

    if (isEqual(items, prevProps.items)) return nextState;
    return mergeToPrevState(nextState, {
      preparedItems: preparedItems,
      prevProps: {
        items: items
      }
    });
  };
}

function updateShuttleStateFromProps (nextProps, prevState) {
  var stateReducers = [compareSelectedItems, compareItems].map(function (fn) {
    return fn(nextProps, prevState.prevProps);
  });
  var nextState = compose.apply(void 0, _toConsumableArray(stateReducers))(prevState);
  return !isEqual(nextState, prevState) ? nextState : null;
}

export default updateShuttleStateFromProps;
//# sourceMappingURL=updateShuttleStateFromProps.js.map
